import { useState } from 'react';
import { fetchPaymentState } from '../../../../../modules/provider/PaymentSettings';
import { useOnce } from '../../../../../hooks';
import { planSelectionEnabled } from '../../../../../modules/provider/planSelection';

const useCommissionPaymentState = (providerId: number) => {
  const [shouldShow, setShouldShow] = useState<boolean>(false);
  const [isPlanSelectionEnabled, setIsPlanSelectionEnabled] = useState<boolean>(false);

  useOnce(async () => {
    const paymentState = await fetchPaymentState(providerId);
    if (
      paymentState.isOnCommissionPlan()
      && !paymentState.isOnboarded()
    ) {
      setShouldShow(true);
      setIsPlanSelectionEnabled(await planSelectionEnabled());
    }
  }, providerId || null);

  return {
    shouldShow,
    planSelectionEnabled: isPlanSelectionEnabled,
  };
};

export default useCommissionPaymentState;
